module.exports = __webpack_public_path__ + "static/media/Article04.402ab963.jpg";